export const MoreSheetTestIds = {
  DRAWER: 'more-sheet.drawer',

  getItemId: id => `more-sheet.item-${id}`,
  getGroupId: id => `more-sheet.group-${id}`,
};
